import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop(): JSX.Element {
  const { pathname } = useLocation();

  useEffect(() => {
    /* Scroll to top on each page load */
    window.scrollTo(0, 0);

    /* Disable broswer go back action on location change */
    window.history.pushState(null, document.title, window.location.href);
  }, [pathname]);

  return <></>;
}
